export const clickOutsideModalActive = (e: Event | undefined): boolean => {
  if (e?.target) {
    const target = e.target as HTMLDivElement;
    // if submenuicon is on mobile view and inside a modal when clicking on a modal or a action menu, the modal shouldn't close.
    if (target.id.includes('bottom-sheet')) return false;
    if (target.id.includes('headlessui')) return true;
  }
  return true;
};
